import { ReactElement, useContext } from 'react'
import { Alert, Snackbar } from '@mui/material'
import DevelopusSnackbarContext from './DevelopusSnackbarContext'
import DevelopusSnackbarActions from './DevelopusSnackbarActions'

const DevelopusSnackbar = (): ReactElement => {
  const snackbarContext = useContext(DevelopusSnackbarContext)
  const snackbarActions = new DevelopusSnackbarActions(snackbarContext)

  const { open, message } = snackbarContext.state

  const handleSnackbarClose = () => {
    snackbarActions.hideSnackbar()
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={handleSnackbarClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        onClose={handleSnackbarClose}
        severity="success"
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}

export default DevelopusSnackbar
